import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import staticHoroscopeService from '../../services/staticHoroscopeService';
import './HoroscopeSection.css';

const HoroscopeSection = () => {
    const [horoscopeData, setHoroscopeData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Liste des 12 signes astrologiques avec leurs icônes
    const signes = [
        { nom: 'Bélier', icon: 'aries.png' },
        { nom: 'Taureau', icon: 'taurus.png' },
        { nom: 'Gémeaux', icon: 'gemini.png' },
        { nom: 'Cancer', icon: 'cancer.png' },
        { nom: 'Lion', icon: 'leo.png' },
        { nom: 'Vierge', icon: 'virgo.png' },
        { nom: 'Balance', icon: 'libra.png' },
        { nom: 'Scorpion', icon: 'scorpio.png' },
        { nom: 'Sagittaire', icon: 'sagittarius.png' },
        { nom: 'Capricorne', icon: 'capricorn.png' },
        { nom: 'Verseau', icon: 'aquarius.png' },
        { nom: 'Poissons', icon: 'pisces.png' }
    ];

    useEffect(() => {
        fetchLatestHoroscope();
    }, []);

    const fetchLatestHoroscope = async () => {
        try {
            setLoading(true);
            const data = await staticHoroscopeService.getLatestHoroscope();

            if (data.success) {
                setHoroscopeData(data.data);
            } else {
                setError('Aucun horoscope disponible pour le moment');
            }
        } catch (err) {
            setError('Erreur lors du chargement de l\'horoscope');
            console.error('Erreur horoscope:', err);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        const options = { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        };
        return date.toLocaleDateString('fr-FR', options);
    };

    const getHoroscopeForSign = (signe) => {
        if (!horoscopeData || !horoscopeData.horoscopes_data || !horoscopeData.horoscopes_data.horoscopes) {
            return null;
        }
        return horoscopeData.horoscopes_data.horoscopes[signe];
    };

    if (loading) {
        return (
            <section className="horoscope-section">
                <div className="container">
                    <div className="horoscope-loading panel">
                        <p>Chargement des horoscopes...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="horoscope-section">
                <div className="container">
                    <div className="horoscope-error panel">
                        <p>{error}</p>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="horoscope-section">
            <div className="container">
                <div className="horoscope-header">
                    <h2>Horoscope Hebdomadaire</h2>
                    {horoscopeData && (
                        <p className="horoscope-date">
                            {formatDate(horoscopeData.timestamp_creation)}
                        </p>
                    )}
                </div>

                <div className="horoscope-grid">
                    {signes.map((signe) => {
                        const horoscope = getHoroscopeForSign(signe.nom);
                        
                        return (
                            <div key={signe.nom} className="horoscope-card panel">
                                <div className="horoscope-card-header">
                                    <div className="signe-symbole">
                                        <img src={`/images/signes_icons/${signe.icon}`} alt={signe.nom} />
                                    </div>
                                    <h3>{signe.nom}</h3>
                                </div>

                                {horoscope ? (
                                    <div className="horoscope-card-content">
                                        <p className="horoscope-resume">
                                            {horoscope.horoscope_resume || 'Résumé temporairement indisponible'}
                                        </p>
                                        <Link to={`/horoscope-hebdomadaire#${signe.nom.toLowerCase()}`} className="horoscope-read-more">
                                            Lire l'horoscope complet
                                        </Link>
                                    </div>
                                ) : (
                                    <div className="horoscope-unavailable">
                                        <p>Horoscope temporairement indisponible</p>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default HoroscopeSection; 